import Purchase from './purchase';

export default {
  name: 'purchase',
  template: `

    <ui-view purchase="$ctrl.purchase"></ui-view>
  `,
  controller: [ '$http',
    class {
      constructor($http) {
        $http.get('/oferta/products')
            .then(response => {
              this.purchase = Purchase.fromJson(response.data)
            });
      }
    }
  ]
};


// WEBPACK FOOTER //
// ./oferta-navidad/purchaseComponent.js